'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

var Paragraph = styled.p.withConfig({
  componentId: "sc-1r04rgk-0"
})(["margin:", ";font-family:", ";font-weight:", ";font-size:", ";color:", ";line-height:", ";"], function (props) {
  return props.s.margin || '0.75rem 0';
}, function (props) {
  return props.s.fontFamily || 'inherit';
}, function (props) {
  return props.s.fontWeight || 'normal';
}, function (props) {
  return props.s.fontSize || '0.875rem';
}, function (props) {
  return props.s.color || '#666';
}, function (props) {
  return props.s.lineHeight || 1;
});
Paragraph.defaultProps = {
  s: {}
};
Paragraph.propTypes = {
  s: PropTypes.shape({
    margin: PropTypes.string,
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string,
    lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

exports.default = Paragraph;
